import React from "react";
import "./footer.scss";

function FooterText() {
  return (
    <div className="footer-text__div media">
      <p className="footer-text_p">
        © 2023 by The Art of Food. Proudly created with Wix.com
      </p>
    </div>
  );
}

export default FooterText;
